module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop-327845861a54d3626ebeafff34b6f888.webp";